var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-skeleton-loader',{attrs:{"aria-busy":false,"type":"card-avatar, article, actions"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }